/**
 * jQuery plugin that stops draggable items colliding when stopCollision is set to true.
 * DEPENDENCIES:
 * - jQuery
 * - jQuery UI
 * 
 * @package 	simPRO
 * @subpackage  jQuery
 * @category    jQuery Plugin
 * @version 	2011-06-28 1.0
 * @author  	Michael West
**/
$.ui.plugin.add("draggable", "stopCollision", {
	drag: function(event, ui) {
        var borderWidth = 0;
        if($(this).hasClass('dayDraggable')){
            borderWidth = 2;
        }
		// Get position of element being dragged
		var iPosition = $(this).position();
		var iLeft = Math.round(ui.offset.left*100)/100;
		var iRight = iLeft + $(this).width() - borderWidth;
        var iTop = Math.round(ui.offset.top*100)/100;
		var iBottom = iTop + $(this).height();
		var draggables = $(".ui-draggable").not($(this));
		$(draggables).each(function(index, item) {
			// Get position of other draggables
			var jOffset = $(item).offset();
			var jLeft = Math.round(jOffset.left*100)/100;
			var jRight = jLeft + $(item).width() - borderWidth;
			var jTop = Math.round(jOffset.top*100)/100;
			var jBottom = jTop + $(item).height();
			// If collision
			if (iLeft < jRight && iRight > jLeft && iTop < jBottom && iBottom > jTop){
				// Stop dragging
				ui.position.top = iPosition.top;
				ui.position.left = iPosition.left;
				return false;
			}
		});
	}
});